export class types {
  uId: string;
  atype: string;
  oauthurl: string;
}
